export function quoteStringOrNull(value) {
    return (value === "null" || value === null) ? null : `"${value}"`;
}
